// extracted by mini-css-extract-plugin
export default {"root":"MCdQY","order-item":"mkWsb","container":"GuPVL","header-container":"evV0o","header-border":"gNSMR","layout":"vmNqZ","content":"vPvGK","pricing-summary-close-button":"bT1LP"};